import { StorageService } from "src/app/shared/services/storage.service";
import {
    Component,
    PLATFORM_ID,
    Inject,
    ViewChild,
    ElementRef,
} from "@angular/core";
// import { isPlatformBrowser } from '@angular/common';
import { LoadingBarService } from "@ngx-loading-bar/core";
import { map, delay, withLatestFrom, filter, first } from "rxjs/operators";
// import { TranslateService } from '@ngx-translate/core';
import { LoginService } from "./auth/login/login.service";
import { NavigationStart, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { IdleDetectionService } from "./shared/services/idle-detection.service";
import { TranslateService } from "@ngx-translate/core";
import { UILanguage } from "src/app/shared/components/header/elements/languages/languages.model";
import { RealtimeService } from "./shared/services/realtime.service";
import { NotificationService } from "./shared/components/header/elements/notification/notification.service";
import { AUTHORIZED_TOKEN, SELECTED_LANGUAGE, SESSION_EXPIRE_TIME } from "./shared/enum/common-enum";
import { PushNotificationService } from "./shared/services/push-notification.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
})
export class AppComponent {

    @ViewChild("message") elementRef: ElementRef;
    // For Progressbar
    loaders = this.loader.progress$.pipe(
        delay(1000),
        withLatestFrom(this.loader.progress$),
        map((v) => v[1])
    );

    title = "af-notification";
    message: any = null;

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private loader: LoadingBarService,
        public storageService: StorageService,
        private translate: TranslateService,
        public loginService:LoginService,
        public router: Router,
        public toaster:ToastrService,
        private realtimeService: RealtimeService,
        private idleDetectionService: IdleDetectionService,
        public notificationService : NotificationService,
        private pushNotificationService : PushNotificationService,
    ) {         
        const userSelectedLanguage = this.storageService.retrieve(SELECTED_LANGUAGE);
        const languageCode = UILanguage.getLanguages()?.find(a => a.locale === userSelectedLanguage)?.languageCode || 'en';
        this.translate.setDefaultLang(languageCode);
        window.addEventListener('beforeunload', () => {
            this.realtimeService?.disposeCieloHubConnection();
            // this.realtimeService?.disposeIdentityConnection();
        });
        this.checkRouterEvent();
    }

    checkRouterEvent(){
        this.router.events.pipe(filter(event => event instanceof NavigationStart),first()).subscribe((event: NavigationStart) => {
                console.log('NavigationStart detected on initial load:',);
                const token = this.storageService.retrieve(AUTHORIZED_TOKEN)
                if (token && event?.url == "/auth/login") {
                    this.router.navigate(["/dashboard"]);
                }
            });
    }

    async ngOnInit() {
        if(location.pathname ==  "/") this.router.navigateByUrl('auth/login');
        this.sessionLogout()
        const accessToken = this.storageService?.retrieve(AUTHORIZED_TOKEN);
        if(accessToken  && location.pathname != '/auth/login') 
        {
            await  this.realtimeService?.createHubConnectionForCielo();
        }
        this.pushNotificationService.requestPermission();

        window.addEventListener('popstate', this.onBackButton.bind(this));
    }

    onBackButton(event: any) {
        if (window.location.pathname === '/auth/select-organization') setTimeout(() => this.router.navigateByUrl('/auth/login'), 100); 
      }

      ngOnDestroy() {
        window.removeEventListener('popstate', this.onBackButton.bind(this));
      }

      sessionLogout(){
        const currentTime = this.storageService?.getCurrentDateTimeInMilliseconds();
        const expiretime = this.storageService?.retrieve(SESSION_EXPIRE_TIME);
        if(currentTime > expiretime) this.router.navigateByUrl('auth/login');
      }
}